import createPersistedState from 'vuex-persistedstate';
import { createStore } from 'vuex';

export default createStore({
  state: {
    user: {
      id: '',
      name: '',
      code: '',
      email: '',
      coteach: '',
      oldcode: ''
    }
  },
  mutations: {
    STORE_USER(state, aUser) {
      state.user.id = aUser.id;
      state.user.name = aUser.name;
      state.user.code = aUser.code;
      state.user.oldcode = aUser.code;
      state.user.email = aUser.email;
      state.user.coteach = aUser.coteach;
    },
    changeCode(state, aCode) {
      state.user.code = aCode;
    },
    changeCoTeach(state, aCode) {
      state.user.coteach = aCode;
    }
  },
  actions: {},
  plugins: [createPersistedState()],
  modules: {}
});